import { useFormContext } from "react-hook-form";
import { useTranslationApp } from "../../../../lib/i18next";
import DateTimeField from "../../../Form/DateTimeField";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  START_DATE_PLACEHOLDER,
  END_DATE_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";
import { ADS_CAMPAIGN_STATUS_DRAFT } from "../../../../utils/constants";
import { addMinutes } from "date-fns";

const AdScheduleContainerMeta = ({ BASIC_PATH, control, disabled = false }) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslationApp();

  // Watch the ad status and dates
  const adStatus = watch(`${BASIC_PATH}.status`);
  const startDate = watch(`${BASIC_PATH}.startDate`);

  // Check if ad is in DRAFT status
  const isDraft = adStatus === ADS_CAMPAIGN_STATUS_DRAFT;

  // Check if startDate is set and is in the future
  const isStartDateTimeInFuture = startDate && new Date(startDate) > new Date();
  // Determine if startDate can be modified
  const canModifyStartDateTime =
    isDraft || (startDate && isStartDateTimeInFuture);

  // Calculate minimum dates
  const now = new Date();
  const minStartDate = isDraft ? now : startDate;
  const minEndDate = startDate
    ? new Date(
        Math.max(new Date(startDate).getTime(), addMinutes(now, 15).getTime())
      )
    : addMinutes(now, 15);

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} xl={6}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            {t(START_DATE_PLACEHOLDER)}
          </Typography>
          <DateTimeField
            name={`${BASIC_PATH}.startDate`}
            control={control}
            disabled={disabled || !canModifyStartDateTime}
            clearable={canModifyStartDateTime}
            minDate={minStartDate}
            errors={errors}
            fullWidth
            variant="filled"
            actionsChange={(date) => {
              // Convert Date object to timestamp
              const timestamp = date ? date.getTime() : null;
              setValue(`${BASIC_PATH}.startDate`, timestamp);
            }}
            showStartNowButton={true}
          />
        </Grid>
        <Grid item xs={12} xl={6}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            {t(END_DATE_PLACEHOLDER)}
          </Typography>
          <DateTimeField
            name={`${BASIC_PATH}.endDate`}
            control={control}
            disabled={disabled}
            clearable={true}
            minDate={minEndDate}
            errors={errors}
            fullWidth
            variant="filled"
            actionsChange={(date) => {
              // Convert Date object to timestamp
              const timestamp = date ? date.getTime() : null;
              setValue(`${BASIC_PATH}.endDate`, timestamp);
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdScheduleContainerMeta;
